howspace.form = {
    /**
     * Asserts that the given URL is valid and starts with the specified protocol.
     */
    validateUrl : (url, protocol = 'https') => {
        if (!url.startsWith(protocol + '://')) {
            return false;
        }

        try {
            new URL(url);
            return true;
        } catch (Exception) {
            return false;
        }
    },
    /**
     * Asserts that at least one checkbox in the given group is selected.
     */
    validateCheckboxSelection : (checkboxGroup) => {
        let isChecked = false;
        checkboxGroup.each(function() {
            if ($(this).is(':checked')) {
                isChecked = true;
                return false; // Exit the loop early if a checkbox is found checked
            }
        });
        if (!isChecked) {
            // Handle the case where no checkboxes are selected
            checkboxGroup.first().closest('.howspace-checkboxes').addClass('has-error');
        } else {
            // Remove error class if at least one checkbox is selected
            checkboxGroup.first().closest('.howspace-checkboxes').removeClass('has-error');
        }

        return isChecked;
    },
    markInvalidField : (field, errorMsg) => {
        // If field is jquery object, convert it to DOM element
        if (field instanceof jQuery) {
            field = field.get(0);
        }
        field.classList.add('is-invalid');
        field.setAttribute('aria-invalid', 'true');

        // Try to find the error message element, should be sibling with class 'invalid-feedback'
        const errorMsgElement = field.nextElementSibling;
        if (errorMsgElement?.classList.contains('invalid-feedback')) {
            errorMsgElement.setAttribute('role', 'alert');
            if (errorMsg !== undefined) {
                errorMsgElement.innerText = errorMsg;
            }
        }
    },
    clearInvalidField : (field) => {
        // If field is jquery object, convert it to DOM element
        if (field instanceof jQuery) {
            field = field.get(0);
        }
        field.classList.remove('is-invalid');
        field.removeAttribute('aria-invalid');

        // Try to find the error message element, should be sibling with class 'invalid-feedback'
        const errorMsgElement = field.nextElementSibling;
        if (errorMsgElement?.classList.contains('invalid-feedback')) {
            errorMsgElement.removeAttribute('role');
        }
    },
    enable : (form) => {
        form.findIncludingSelf('.howspace-form-label').removeClass('disabled');
        form.findIncludingSelf('fieldset').prop('disabled', false).removeClass('disabled');
        form.find('input, textarea, select, button').prop('disabled', false).removeClass('disabled');
    },
    disable : (form) => {
        form.findIncludingSelf('.howspace-form-label').addClass('disabled');
        form.findIncludingSelf('fieldset').prop('disabled', true).addClass('disabled');
        form.find('input, textarea, select, button').prop('disabled', true).addClass('disabled');
    },
    focusFirstInput: (elem) => {
        if (!(elem instanceof jQuery)) {
            elem = $(elem);
        }

        const firstInput = elem.find('input:visible:not([type="checkbox"],[type="radio"],.disabled,[disabled]), select:visible:not(.disabled,[disabled]), textarea:visible:not(.disabled,[disabled]), .howspace-text-editor').first();

        if (!firstInput.length) {
            return;
        }

        howspace.focusFirstInput = false;

        if (firstInput.hasClass('howspace-text-editor')) {
            if (firstInput.hasClass('howspace-text-editor-initialized')) {
                howspace.components.textEditor.focus(firstInput);
            } else {
                firstInput[0].addEventListener(howspace.components.textEditor.INITIALIZED, () => {
                    howspace.components.textEditor.focus(firstInput);
                }, {once: true});
            }
        } else {
            real.input.focus(firstInput[0]);
        }
    }
};
